/* eslint-disable react-hooks/exhaustive-deps,react/no-unknown-property */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable import/prefer-default-export */
import React, { useMemo } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { currencies, exchange } from '../../../utilities/constants';
import { IconWithLabel, ItemLayout } from '../../shared/TabContentLayouts';
import { COLLATERAL_MARGIN_PERCENTAGE, LOAN_STATUS } from '../constants';
import { useRate } from '../../../utilities/sharedHooks/rates';
import { getLoanDetailsHelper } from '../helpers';
import { formatNumber } from '../../../utilities/formatHelpers';

export const LoanItem = ({ data, onClick }) => {
  const { t: translate } = useTranslation();
  const principalCurrency = data.principal_currency.toUpperCase();
  const collateralCurrency = data.collateral_currency.toUpperCase();

  const availableBalance = formatNumber(
    data.net_principal_amount * currencies[principalCurrency].conversion,
    exchange.FIAT_VALUE
  );
  const collateralAmount = data.collateral_amount * currencies[collateralCurrency].conversion;

  const isSettledLoan = data.status === LOAN_STATUS.SETTLED;

  const dueDate = moment(data.loan_due_at).format('MM/DD/YYYY');

  const isPending = data.status === LOAN_STATUS.PENDING;
  const isInterestsOverdue = useMemo(() => data.missed_payments_count > 0, [data]);

  const rate = useRate(collateralCurrency, principalCurrency);
  const { formattedCurrentLTV: currentLTV } = useMemo(
    () => getLoanDetailsHelper(data, rate),
    [data, rate]
  );
  const isCollateralNeeded =
    // eslint-disable-next-line no-restricted-globals
    isFinite(currentLTV) &&
    currentLTV - data.ltv_percentage_initial > COLLATERAL_MARGIN_PERCENTAGE &&
    !isSettledLoan;

  const loanNotification = useMemo(() => {
    if (isCollateralNeeded) {
      return {
        type: 'danger',
        message: translate('loan_transaction_collateral_needed'),
      };
    }
    if (isPending) {
      return {
        type: 'warning-light',
        message: translate('loan_transaction_pending_note'),
      };
    }
    if (isInterestsOverdue) {
      return {
        type: 'info-light',
        message: translate('loan_transaction_missing_interest'),
      };
    }

    return { type: '', message: '' };
  }, [isCollateralNeeded, isPending, isInterestsOverdue]);

  return (
    <ItemLayout
      withHover={false}
      onClick={() => onClick({ isCollateralNeeded, isPending, isInterestsOverdue, ...data })}
      noteType={loanNotification.type}
      note={loanNotification.message}>
      <IconWithLabel
        icon={principalCurrency}
        label={`${principalCurrency}/${collateralCurrency}`}
        subLabel={translate('loans_loan_sub_label').replace(
          '%s',
          `${formatNumber(
            collateralAmount,
            currencies[collateralCurrency].decimal
          )} ${collateralCurrency}`
        )}
        col="4"
        mobileCol="8"
      />
      <b className="d-none d-md-block" col="3">{`${availableBalance} ${principalCurrency}`}</b>
      <b className="d-none d-md-block" col="3">{`${dueDate}`}</b>
      {!isSettledLoan && (
        <button
          col="2"
          isright="true"
          className="d-none d-md-block btn p-0 text-primary text-f6 text-btn-item border-0"
          type="button"
          onClick={() =>
            onClick({
              isCollateralNeeded,
              isPending,
              isInterestsOverdue,
              ...data,
            })
          }>
          <b>{translate('loans_loan_cta_button_label')}</b>
        </button>
      )}

      <div mobileCol="4" col="3" isright="true" className="d-flex d-md-none flex-column">
        <b>{`${availableBalance}`}</b>
        <p className="text-f6 text-shadow">{`${dueDate}`}</p>
      </div>
    </ItemLayout>
  );
};

LoanItem.propTypes = {
  data: PropTypes.any,
  onClick: PropTypes.func,
};
LoanItem.defaultProps = {
  data: null,
  onClick: null,
};
